import script from "./legoTabBox.vue?vue&type=script&lang=js"
export * from "./legoTabBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/lego-component/components/boxes/legoTabBox/legoTabBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06b15c35"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06b15c35', __exports__)) {
    api.reload('06b15c35', __exports__)
  }
  
}


export default __exports__